<template>
  <div id="index" ref="appRef">
    <div class="bg">
      <video class="bg-video" autoplay loop muted playsinline>
        <source src="@/assets/1678779171725-jwprOaEf.mp4" type="video/mp4">
      </video>
      <dv-loading v-if="loading">Loading...</dv-loading>
      <div v-else class="host-body">
        <!-- Header 组件 -->
        <PageHeader :showNav="true" activeNavKey="enterprise"/>

        <div class="center">
          <!-- 标题栏 -->
          <div class="page-title">
            <span class="title-icon"></span>
            <span class="title-text">四大产业链及代表企业</span>
          </div>

          <!-- 主要内容区域 -->
          <div class="main-content">
            <!-- 左侧：四个表格 -->
            <div class="left-section">
              <div
                  v-for="(category, index) in categories"
                  :key="index"
                  class="table-container"
                  :class="'table-' + (index + 1)"
              >
                <!-- 左侧边栏 -->
                <div class="table-sidebar">
                  <div class="sidebar-top">
                    <div class="sidebar-icon">
                      <img :src="category.icon" alt=""/>
                    </div>
                    <div class="sidebar-title-line">{{ category.title1 }}</div>
                  </div>
                  <div class="sidebar-title-line">{{ category.title2 }}</div>
                </div>

                <!-- 主表格区域 -->
                <div class="table-main">
                  <div class="table-content">
                    <!-- 只有第一个表格显示表头 -->
                    <div v-if="index === 0" class="table-row table-header-row">
                      <div class="table-cell cell-name" style="margin-right: 65px;">单位名称</div>
                      <div class="table-cell cell-time">工会成立时间</div>
                      <div class="table-cell cell-tax">年纳税额</div>
                      <div class="table-cell cell-worker">职工人数</div>
                      <div class="table-cell cell-bachelor">本科以上</div>
                      <div class="table-cell cell-bachelor">专利数</div>
                      <div class="table-cell cell-bachelor">党员人数</div>
                      <div class="table-cell cell-bachelor">全年活动</div>
                      <div class="table-cell cell-bachelor">技能培训</div>
                      <div class="table-cell cell-bachelor">安全培训</div>
                    </div>
                    <div class="table-body" ref="tableBody">
                      <div v-for="(item, idx) in category.data" :key="idx" class="table-row">
                        <div class="table-cell cell-name" style="width: 200px;">
                          <span class="status-dot" :class="'dot-' + (idx % 3 + 1)"></span>
                          <div class="name-scroll-wrapper" :ref="'nameWrapper-' + index + '-' + idx">
                            <div
                                class="name-scroll-content"
                                :class="{ 'scroll-active': item.needScroll }"
                                :ref="'nameContent-' + index + '-' + idx"
                            >
                              {{ item.name }}
                            </div>
                          </div>
                        </div>
                        <div class="table-cell cell-time">{{ item.time }}</div>
                        <div class="table-cell cell-worker">{{ item.tax }}</div>
                        <div class="table-cell cell-worker">{{ item.worker }}</div>
                        <div class="table-cell cell-bachelor">{{ item.bachelor }}</div>
                        <div class="table-cell cell-special">{{ item.special }}</div>
                        <div class="table-cell cell-special">{{ item.party }}</div>
                        <div class="table-cell cell-activity">{{ item.activity }}</div>
                        <div class="table-cell cell-activity">{{ item.skill }}</div>
                        <div class="table-cell cell-safety">{{ item.safety }}</div>
                      </div>
                    </div>
                    <div class="table-more">...</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 右侧：两个轮播图 -->
            <div class="right-section">
              <!-- 上方轮播图 -->
              <div class="carousel-container">
                <div class="carousel-title">企业技能比武与安全培训</div>
                <div class="carousel-wrapper">
                  <transition name="fade">
                    <img
                        :key="currentTopImage"
                        :src="topImages[currentTopImage]"
                        class="carousel-image"
                        alt="企业活动"
                    />
                  </transition>
                </div>
              </div>

              <!-- 下方轮播图 -->
              <div class="carousel-container">
                <div class="carousel-title">企业活动风采</div>
                <div class="carousel-wrapper">
                  <transition name="fade">
                    <img
                        :key="currentBottomImage"
                        :src="bottomImages[currentBottomImage]"
                        class="carousel-image"
                        alt="企业风采"
                    />
                  </transition>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-container">
          <PageFooter />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/page-header/index.vue'
import drawMixin from '../utils/drawMixin'
import {get} from "@/utils/request";
import PageFooter from "_c/page-footer/index.vue";

export default {
  name: 'Enterprise',
  mixins: [drawMixin],
  components: {
    PageFooter,
    PageHeader,
  },
  data() {
    return {
      VUE_APP_API_BASE_URL:"https://dp.houkongfan.cn",
      loading: false,
      currentTopImage: 0,
      currentBottomImage: 0,
      topImages: [],
      bottomImages: [],
      categories: [
        {
          name: '高端装备产业链',
          title1: '权益共护',
          title2: '高端装备产业链',
          icon: require('@/assets/page4/1762090144778-q1QPEax-.png'),
          data: []
        },
        {
          name: '智能制造产业链',
          title1: '产数融合',
          title2: '智能制造产业链',
          icon: require('@/assets/page4/1762090194132-59yiDQo4.png'),
          data: []
        },
        {
          name: '高端纺织产业链',
          title1: '高端装备',
          title2: '高端纺织产业链',
          icon: require('@/assets/page4/1762090274658-1e0ZNq19.png'),
          data: []
        },
        {
          name: '大快消产业链',
          title1: '职善生活',
          title2: '大快消产业链',
          icon: require('@/assets/page4/1762090345566-0FNn6c2t.png'),
          data: []
        }
      ],
      topCarouselTimer: null,
      bottomCarouselTimer: null,
    }
  },
  mounted() {
    this.onLoadInfo()
  },
  beforeDestroy() {
    this.stopCarousels()
  },
  methods: {


    // 提取公共的数据映射方法
    mapEnterpriseData(item) {
      return {
        name: item.dwname,
        time: item.ghclsj + "年",
        tax: item.nnse,
        worker: item.zgsr,
        bachelor: item.benke,
        special: item.zls,
        party: item.dyrs,
        activity: item.qnhd,
        skill: item.jnpx,
        safety: item.aqpx,
      }
    },


    // 修改 onLoadInfo 方法中的数据处理部分
    async onLoadInfo() {
      this.loading = true
      const url =this.VUE_APP_API_BASE_URL + "/dev-api/system/page4/queryList"
      const result = await get(url)
      if (result.success) {
        let data = result.data
        // 使用公共方法映射各产业链数据
        this.categories[0].data = data.gdzbList?.map(this.mapEnterpriseData) || []
        this.categories[1].data = data.znzzList?.map(this.mapEnterpriseData) || []
        this.categories[2].data = data.gdfzList?.map(this.mapEnterpriseData) || []
        this.categories[3].data = data.dkxList?.map(this.mapEnterpriseData) || []

        // 企业技能比武与安全培训 - 提取图片URL
        if (data.imgList1 && Array.isArray(data.imgList1)) {
          this.topImages = data.imgList1.map((item) => {
            // 拼接完整的图片路径
            return this.VUE_APP_API_BASE_URL +`/dev-api${item.imgurl}`;
          });
        }
        //企业活动风采
        if (data.imgList2 && Array.isArray(data.imgList2)) {
          this.bottomImages = data.imgList2.map((item) => {
            // 拼接完整的图片路径
            return this.VUE_APP_API_BASE_URL +`/dev-api${item.imgurl}`;
          });
        }
      }
      this.startCarousels()
      this.checkTextOverflow()
      this.loading = false
    },
    // 检查文本是否溢出，决定是否需要滚动
    checkTextOverflow() {
      // 添加防抖避免频繁调用
      if (this.checkOverflowTimer) {
        clearTimeout(this.checkOverflowTimer);
      }
      this.checkOverflowTimer = setTimeout(() => {
        this.categories.forEach((category, categoryIndex) => {
          category.data.forEach((item, itemIndex) => {
            console.log(item)
            const wrapperRefName = `nameWrapper-${categoryIndex}-${itemIndex}`;
            const contentRefName = `nameContent-${categoryIndex}-${itemIndex}`;

            const wrapperElement = this.$refs[wrapperRefName]?.[0];
            const contentElement = this.$refs[contentRefName]?.[0];

            if (wrapperElement && contentElement) {
              const wrapperWidth = wrapperElement.offsetWidth;
              const contentWidth = contentElement.scrollWidth;

              // 直接修改属性而非使用 this.$set
              item.needScroll = contentWidth > wrapperWidth;
            }
          });
        });
      }, 100);
    },
    startCarousels() {
      // 上方轮播图，每4秒切换
      this.topCarouselTimer = setInterval(() => {
        this.currentTopImage = (this.currentTopImage + 1) % this.topImages.length
      }, 4000)

      // 下方轮播图，每5秒切换（与上方错开）
      this.bottomCarouselTimer = setInterval(() => {
        this.currentBottomImage = (this.currentBottomImage + 1) % this.bottomImages.length
      }, 5000)
    },
    stopCarousels() {
      if (this.topCarouselTimer) {
        clearInterval(this.topCarouselTimer)
      }
      if (this.bottomCarouselTimer) {
        clearInterval(this.bottomCarouselTimer)
      }
    }
  },
}
</script>

<style lang="scss" scoped>
#index {
  color: #d3d6dd;
  width: 1920px;
  height: 1080px;
  position: fixed;
  left: 0;
  top: 0;
  transform-origin: left top;
  overflow: hidden;

  .bg {
    width: 100%;
    min-height: 100%;
    padding: 16px 16px 20px 16px;
    background-image: url('../assets/bj.jpg');
    background-size: cover;
    background-position: center center;
    position: relative;

    .bg-video {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      opacity: 0.3;
      z-index: 0;
      pointer-events: none;
    }
  }

  .host-body {
    .center {
      width: 100%;
      margin-top: 10px;
    }

    // 页面标题
    .page-title {
      display: flex;
      // align-items: center;
      // justify-content: center;
      gap: 12px;
      padding: 12px 0;
      margin-bottom: 10px;
      width: 340px;
      height: 50px;
      background-image: url('~@/assets/page4/1678762303238-H4hA_Hb9.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center center;
      .title-icon {
        font-size: 28px;
      }

      .title-text {
        font-size: 18px;
        font-weight: 700;
        color: #00d9ff;
        text-shadow: 0 0 10px rgba(0, 217, 255, 0.5);
        letter-spacing: 2px;
        margin-left: 50px;
      }
    }


    // 主内容区
    .main-content {
      display: flex;
      gap: 20px;
      padding: 0 16px;
      height: calc(1080px - 200px);
    }

    // 左侧表格区域
    .left-section {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 15px;
      overflow: hidden;
    }

    .table-container {
      flex: 1;
      border-radius: 8px;
      overflow: hidden;
      display: flex;
      flex-direction: row;
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
      min-height: 0;

      // 左侧边栏
      .table-sidebar {
        width: 140px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 12px;
        padding: 20px 10px;
        border-right: 1px solid rgba(255, 255, 255, 0.15);

        .sidebar-top {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }

        .sidebar-icon {
          font-size: 36px;
          filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.3));
          flex-shrink: 0;

          img {
            width: 36px;
            height: 36px;
            object-fit: contain;
            display: block;
          }
        }

        .sidebar-title-line {
          font-size: 16px;
          font-weight: 600;
          line-height: 1.4;
          letter-spacing: 1px;
          white-space: nowrap;
          text-align: center;
        }
      }

      // 主表格区域
      .table-main {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }

      .table-header {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 10px 16px;
        font-size: 14px;
        font-weight: 600;

        .header-icon {
          font-size: 18px;
        }

        .header-title {
          flex: 1;
          letter-spacing: 0.3px;
        }
      }

      .table-content {
        flex: 1;
        overflow: hidden;
        display: flex;
        flex-direction: column;
      }

      .table-row {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: 600;
        border-bottom: 1px solid rgba(255, 255, 255, 0.06);
        padding: 8px 12px;
        min-height: 50px;
        transition: all 0.3s ease;
        cursor: pointer;

        &.table-header-row {
          font-weight: 700;
          font-size: 17px;
          opacity: 0.95;
          border-bottom: 1px solid rgba(255, 255, 255, 0.15);
          padding: 14px 24px;
          background: rgba(255, 255, 255, 0.03);
          cursor: default;

          // 表头不放大
          &:hover {
            transform: none;
            background: rgba(255, 255, 255, 0.03);
          }
        }

        // 数据行悬停效果
        &:not(.table-header-row):hover {
          transform: scale(1.05);
          background: rgba(255, 255, 255, 0.08);
          z-index: 10;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);

          .table-cell {
            font-size: 19px;
          }
        }

        &:last-child {
          border-bottom: none;
        }
      }

      .table-body {
        flex: 1;
        overflow: hidden;
      }

      .table-cell {
        padding: 0 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: center;

        &.cell-name {
          flex: 1;
          min-width: 200px;
          max-width: 350px;
          display: flex;
          align-items: center;
          gap: 12px;
          overflow: hidden;
          text-align: left;
          padding-right: 24px;

          .status-dot {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            flex-shrink: 0;

            &.dot-1 {
              background: #ffd700;
              box-shadow: 0 0 10px #ffd700;
            }

            &.dot-2 {
              background: #e0e0e0;
              box-shadow: 0 0 10px #e0e0e0;
            }

            &.dot-3 {
              background: #ff9966;
              box-shadow: 0 0 10px #ff9966;
            }
          }

          .name-scroll-wrapper {
            flex: 1;
            overflow: hidden;
            position: relative;

            .name-scroll-content {
              display: inline-block;
              white-space: nowrap;
              padding-right: 20px;

              // 只有溢出的文本才添加滚动动画
              &.scroll-active {
                animation: scrollName 10s linear infinite;
              }
            }

            &:hover .name-scroll-content.scroll-active {
              animation-play-state: paused;
            }
          }
        }

        &.cell-time {
          width: 150px;
          font-size: 17px;
        }

        &.cell-tax {
          width: 98px;
          font-weight: 600;
          color: #88ccff;
        }

        &.cell-worker {
          width: 92px;
        }

        &.cell-bachelor {
          width: 92px;
        }

        &.cell-special {
          width: 85px;
          color: #ffaa44;
          font-weight: 700;
        }

        &.cell-party {
          width: 92px;
          color: #ff8888;
          font-weight: 700;
        }

        &.cell-activity {
          width: 92px;
        }

        &.cell-skill {
          width: 92px;
          color: #55ffbb;
          font-weight: 700;
        }

        &.cell-safety {
          width: 92px;
          color: #ffcc33;
          font-weight: 700;
        }
      }

      .table-more {
        text-align: center;
        font-size: 28px;
        opacity: 1;
        letter-spacing: 3px;
        font-weight: bold;
      }

      // 第一个表格 - 蓝色
      &.table-1 {
        background: linear-gradient(135deg, rgba(0, 100, 200, 0.2), rgba(0, 150, 255, 0.1));
        border: 1px solid rgba(0, 150, 255, 0.4);

        .table-sidebar {
          background: linear-gradient(180deg, rgba(0, 120, 220, 0.5), rgba(0, 100, 200, 0.3));
          color: #5db8ff;
        }

        .table-header {
          background: rgba(0, 120, 220, 0.4);
          color: #5db8ff;
        }

        .table-header-row {
          background: rgba(0, 100, 200, 0.3);
          color: #8dd0ff;
        }
      }

      // 第二个表格 - 绿色
      &.table-2 {

        background: linear-gradient(135deg, rgba(0, 150, 100, 0.2), rgba(0, 200, 150, 0.1));
        border: 1px solid rgba(0, 200, 150, 0.4);

        .table-sidebar {
          background: linear-gradient(180deg, rgba(0, 170, 120, 0.5), rgba(0, 150, 100, 0.3));
          color: #5dffb8;
        }

        .table-header {
          background: rgba(0, 170, 120, 0.4);
          color: #5dffb8;
        }

        .table-header-row {
          background: rgba(0, 150, 100, 0.3);
          color: #8dffd0;
        }
        .table-main{
          margin-top: 32px;
        }
      }

      // 第三个表格 - 黄色
      &.table-3 {
        background: linear-gradient(135deg, rgba(200, 150, 0, 0.2), rgba(255, 200, 0, 0.1));
        border: 1px solid rgba(255, 200, 0, 0.4);

        .table-sidebar {
          background: linear-gradient(180deg, rgba(220, 170, 0, 0.5), rgba(200, 150, 0, 0.3));
          color: #ffd75d;
        }

        .table-header {
          background: rgba(220, 170, 0, 0.4);
          color: #ffd75d;
        }

        .table-header-row {
          background: rgba(200, 150, 0, 0.3);
          color: #ffe58d;
        }
        .table-main{
          margin-top: 32px;
        }
      }

      // 第四个表格 - 红色
      &.table-4 {
        background: linear-gradient(135deg, rgba(200, 50, 50, 0.2), rgba(255, 100, 100, 0.1));
        border: 1px solid rgba(255, 100, 100, 0.4);

        .table-sidebar {
          background: linear-gradient(180deg, rgba(220, 70, 70, 0.5), rgba(200, 50, 50, 0.3));
          color: #ff8d8d;
        }

        .table-header {
          background: rgba(220, 70, 70, 0.4);
          color: #ff8d8d;
        }

        .table-main{
          margin-top: 32px;
        }

        .table-header-row {
          background: rgba(200, 50, 50, 0.3);
          color: #ffb8b8;
        }
      }
    }

    // 右侧轮播区域
    .right-section {
      width: 520px;
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

    .carousel-container {
      flex: 1;
      background: rgba(0, 217, 255, 0.05);
      border: 1px solid rgba(0, 217, 255, 0.3);
      border-radius: 8px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);

      .carousel-title {
        padding: 12px 16px;
        background: rgba(0, 217, 255, 0.15);
        color: #00d9ff;
        font-size: 18px;
        font-weight: 600;
        text-align: center;
        letter-spacing: 1px;
        border-bottom: 1px solid rgba(0, 217, 255, 0.3);
      }

      .carousel-wrapper {
        flex: 1;
        position: relative;
        overflow: hidden;
        background: rgba(0, 0, 0, 0.3);

        .carousel-image {
          position: absolute;
          width: 100%;
          height: 100%;
          object-fit: cover;
          left: 0;
          top: 0;
        }
      }
    }

    // 淡入淡出动画
    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 1s ease;
    }

    .fade-enter,
    .fade-leave-to {
      opacity: 0;
    }

    .fade-enter-to,
    .fade-leave {
      opacity: 1;
    }

    // 单位名称滚动动画
    @keyframes scrollName {
      0% {
        transform: translateX(0);
      }
      100% {
        transform: translateX(-100%);
      }
    }
  }
}
</style>

